import router from './../../router'
import TokenService from './../../services/token.service'
import ApiService from '../../services/api.service'
import { ACCOUNT_LOGIN, ACCOUNT_INFO, ACCOUNT_LOGOUT } from "./../actions.type"
import {
    SET_TOKEN,
    SET_ERRORS,
    SET_USER,
    TOKEN_OUT_OF_DATE
} from "./../mutations.type"
import User from '../models/User'
import allRoutes from '@/routes/all.routes'

const state = {
    errors: null,
    user: new User(),
    isAuthorize: !!TokenService.getToken()
}

const getters = {
    isAuthenticated(state) {
        return state.isAuthorize;
    },
    user(state) {
        return state.user;
    },
    isAdministrator(state) {
        return state.user.Rights.Id == 1;
    },
    isMyfoodsal(state) {
        return state.user.Email === 'myfoodsal@gmail.com'
    },
    isClientMain(state) {
        return state.user.Email === 'oputina@may-foods.ru'
    }
}

const actions = {
    [ACCOUNT_LOGIN](context, loginDto) {

        return new Promise((resolve, reject) => {

            ApiService.Account.PostLogin(loginDto)
                .then(response => {
                    context.commit(SET_TOKEN, response.data);
                    context.commit(SET_USER, response.data);                    
                    resolve("successful");
                })
                .catch(response => {
                    context.commit(SET_ERRORS, response);
                    reject(response);
                });
        });        
    },
    [ACCOUNT_INFO](context) {
        ApiService.Account.GetInfo()
            .then((response) => {
                context.commit(SET_USER, response.data);
            })
            .catch(response => {
                if (response == 401) {
                    context.commit(TOKEN_OUT_OF_DATE);
                }
            });
    },
    [ACCOUNT_LOGOUT](context) {
        context.commit(TOKEN_OUT_OF_DATE);
        router.push(allRoutes.Account.Login);
    }
}

const mutations = {
    [SET_TOKEN](state, user) {
        state.isAuthorize = true;
        TokenService.setToken(user.Token);
    },
    [SET_USER](state, userDto) {
        state.user = new User().mapFromDto(userDto);
    },
    [SET_ERRORS](state, error) {
        state.errors = error;
    },
    [TOKEN_OUT_OF_DATE](state) {
        state.user = null;
        state.isAuthorize = false;
        TokenService.destroyToken();
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}